import { useNavigate } from 'react-router-dom'
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useProject } from '../../context/ProjectContext'

const LoginWasNotCompletedModal = ({
  loginWasNotCompletedOpen,
  setLoginWasNotCompletedOpen
}) => {
  const navigate = useNavigate()
  const { selectedProject } = useProject()

  const handleClose = () => {
    setLoginWasNotCompletedOpen(false)
  }

  const handleGoToLoginSettings = () => {
    navigate(`/project/${selectedProject.id}`, { state: { activeTab: '2' } })
  }

  return (
    <Dialog open={loginWasNotCompletedOpen} onClose={handleClose}>
      <Box className="loginWasNotCompletedModal">
        <DialogTitle className="loginWasNotCompletedModalTitle">
          <InfoOutlinedIcon className="loginWasNotCompletedModalTitleIcon" color='secondary'/>
          Login was not completed
        </DialogTitle>
        <DialogContent className="loginWasNotCompletedModalContent">
          <Typography variant='body1'>
            Test case generation won’t be available unless login is completed.<br/>
            To enable this functionality, please go to&nbsp;
            <span
              className="loginWasNotCompletedModalContentLink"
              onClick={handleGoToLoginSettings}
            >
              Login Settings
            </span> and click<br/>
            <strong>Re-login</strong> to complete the login flow.
          </Typography>
        </DialogContent>
        <DialogActions className="loginWasNotCompletedModalActions">
          <Button className="loginWasNotCompletedModalButton" onClick={handleClose} color="secondary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default LoginWasNotCompletedModal